import React, { useEffect } from 'react';
import BookingFieldsBlock from './BookingFieldsBlock';
import Price from './Price';
import TimeZone from '../../components/Common/TimeZone';
import VariantsBlock from './VariantsBlock';
import { stringToBoolean } from '../../utilities/conversionUtility';

export default function EventsListConfirmationPage(props) {
  const {
    canBook,
    closeModal,
    dateFormat,
    enableLocationDropdown,
    enableResourceDropdown,
    getValidationFn,
    locale,
    productTitle,
    renderSubmitButton,
    selectedLocation,
    selectedResource,
    setting,
    setWrapperHeight,
    style,
    timeInterval,
    timeSlotSelected,
    timeZone,
    translation,
    variants,
  } = props;

  useEffect(() => setWrapperHeight(), []);

  return (
    <div>
      <button type="button" className="btn-back-title" style={style.body} onClick={closeModal}>
        <i className="fa fa-arrow-left fa-2" aria-hidden="true" />
      </button>

      <h3 className="activity-title text-center" style={{ ...style.title }} />

      <p className="mt0 description-title">{translation.key('descriptionModal')}</p>

      <div>
        <VariantsBlock
          productTitle={productTitle}
          variants={Object.values(variants)}
          selectedTimeSlot={timeSlotSelected}
          selectedResource={selectedResource}
          selectedLocation={selectedLocation}
          enableResourceDropdown={enableResourceDropdown}
          enableLocationDropdown={enableLocationDropdown}
          locale={locale}
          timeZone={timeZone}
          timeFormat={setting.time_format}
          selectDifferentTime={closeModal}
          style={style}
        />

        <BookingFieldsBlock
          translation={translation}
          getValidationFn={(validationFn) => getValidationFn(validationFn)}
          willUpdate={() => setWrapperHeight()}
          timeZone={timeZone}
          timeInterval={timeInterval}
          dateFormat={dateFormat}
        />

        <TimeZone
          timeZone={timeZone}
          selectedTime={timeSlotSelected ? timeSlotSelected.start : null}
        />
        <Price style={{ ...style.body }} title={translation.key('total')} />
      </div>
      <div>
        {renderSubmitButton(canBook)}
      </div>
    </div>
  );
}
